import { ConversationListPage } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetConversationsRequest = {
	offset?: number;
	pageSize?: number;
};

export const getConversations = createGetEndpoint<GetConversationsRequest, ConversationListPage>(
	({ offset = 0, pageSize = 20 } = {}) => `/api/v3/agent/conversations?${getQueryString({
		offset,
		pageSize
	})}`
);
